import Config from '../definitions/Config';
import fetchWithStatusError from './fetchWithStatusError';
import withProfileApiError from './withProfileApiError';


const API_ENDPOINT = `${Config.PROFILE_BFF_URL}/save-document`;

/**
 * @param { object } document
 * @param {string } documentType
 * @returns {Promise<{ profile?: any }>} profile without documents node inside
 */
async function pushDocument(document, documentType) {
    const response = await fetchWithStatusError(`${API_ENDPOINT}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-ratehub-mtgunifieddoc': '1',
        },
        credentials: 'include',
        body: JSON.stringify({
            document,
            documentType,
            docTokenRequested: false,
        }),
    });

    // profile-faas < 1.15.0 doesn't return body
    // TODO: remove try/catch block when profile-faas 1.15.0 makes on PROD
    try {
        // NOTE: there is **NO** valid check in response body yet, might need in the future
        const responseBody = await response.json();
        return responseBody.data ?? {}; // expecting { profile: null | object }
    } catch (_) {
        return {};
    }
}

export default withProfileApiError(pushDocument);
export {
    API_ENDPOINT,
};
